import { Component, OnInit } from '@angular/core';

import { ControllerService } from '../../shared/services/controller.service';
import { HttpService } from '../../shared/services/http.service';
import { StoreHelper } from '../../shared/helpers/store.helper';
import { environment } from '../../../environments/environment';

declare var $: any;

declare global {
  interface Window {
    submitted: any;
  }
}

// /complete handler

@Component({
    selector: 'app-survey',
    templateUrl: './survey.component.html',
    styleUrls: ['./survey.component.scss'],
    standalone: false
})
export class SurveyComponent implements OnInit {

  components = []

  survey = ''

  typeformid = false

  showSurvey = false

  code = ''

  showSurveyButton = false

  page: any


  constructor( public controller:ControllerService, private httpService: HttpService) {
    // document.body.classList.add('welcome_1');
  }

  isBeta(){
    return environment.production ? "false": "true"
  }

  getHidden(){
    return 'code=' + this.code + ',beta=' + this.isBeta() + ',client=' + StoreHelper.getCurrentUser().client_name
  }

  async complete(){

    await window.location.reload()

  }

  async ngOnInit() {

    this.components = this.controller.getSectionComponents()

    this.code = this.controller.getActivationCode()

    const props = this.controller.getSectionProperties()

    if( props.showSurveyButton == 'true'){
      this.showSurveyButton = true
    }

    this.page = this.components[0]
    const surveyLink = this.components[0].elements.find( ({type}) => type == 'survey-link')

    if( surveyLink ){
      this.survey = surveyLink.value
    }

    this.typeformid = props.typeformid

    if( props.emailActions == 'true'){
      // send actions (and possibly cpd).
      const selectedActions = this.controller.getSelectedActions().map( ({title}) => title)

      const actions = this.controller.getActions()

      // filter here to get only actions with added

      const actionsToSend = actions.actions.filter( ({title}) => selectedActions.includes(title) )

      const myItems = actionsToSend.map( ({title,emailComment,comment}) =>  ({title, comment : emailComment ? emailComment:comment }) )

      const alreadySentActions = this.controller.getCookie('sentActions')

      if( alreadySentActions == "true"){
        return
      }
      try{
        const response :any = await this.httpService.postAsync("actions/send", {
          actions : myItems,
          type: actions.type,
          contentId: this.controller.getContentId(),
        })
        if( response && response.success ){
          this.controller.setCookie('sentActions', "true", 10)
          this.controller.setErrorMessage("")
        }else{
          this.controller.setErrorMessage("Error processing your request, please refresh the page to try again.")
        }
      }catch(e){

      }

    }
  }

  onGoToSurvey() {

    if( !this.typeformid ){
      window.open(this.survey,'_blank')
      this.controller.setDoneTraining()
      this.controller.goToLibrary()
      return
    }

    this.showSurvey = true

    const src = 'https://embed.typeform.com/next/embed.js'

    let scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.src = src;

    document.getElementsByTagName('head')[0].appendChild(scriptElement);

    window.submitted = function(){
      this.complete()
    }.bind(this)

  }

  gotoLibrary(){
    this.controller.goToLibrary()
  }

}
